import React, { Component } from "react";
import ReactTooltip from "react-tooltip";

import { ICategorySlideComponentProps } from "../types/props";
import { CATEGORY_CONFIG } from "../config";
import BrochureTitleSlideComponent from "../titleSlideComponent/titleSlide.component";
import "./categorySlide.component.scss";
class BrochureCategorySlideComponent extends Component<ICategorySlideComponentProps> {
  render() {
    return (
      <div className="category-slide">
        <ReactTooltip backgroundColor="rgb(0, 51, 89)" />
        {/* <div className="category-slide--left">
          <div className="category-slide--buttons">
            <button
              className="category-slide--up"
              disabled={this.props.index === 0}
              onClick={this.up}
            >
              <span className="sr-only">Move Up</span>
            </button>
            <button
              className="category-slide--down"
              disabled={this.props.last}
              onClick={this.down}
            >
              <span className="sr-only">Move Down</span>
            </button>
          </div>
        </div> */}
        <div className="category-slide--right">
          <div className="category-slide--header">
            <h3>{this.getCategory()}</h3>
          </div>
          {this.titleList()}
        </div>
      </div>
    );
  }

  titleList = (): JSX.Element[] => {
    return this.props.sections.map((section, index) => {
      return (
        <div className="title-view-link" key={index}>
          <BrochureTitleSlideComponent
            key={index}
            section={section}
            challenge={section.name}
            category={this.props.category}
            name={section.name}
            meta={section.meta}
            index={index}
            last={index === this.props.sections.length - 1}
            removeSlide={this.props.removeSlide}
          />
        </div>
      );
    });
  };

  getCategory = () => {
    const category = CATEGORY_CONFIG[this.props.category];
    if (category === undefined) {
      return `Not Configured`;
    } else return category;
  }
}

export default BrochureCategorySlideComponent;
